const log = {
    invalid_type: 'O tipo de registro é inválido.',
};
export default log;
